export const before = (target: Element, elem: Element | string) => {
  if (target.parentNode) {

    if (typeof elem === 'string') {
      // 使用 Range 将字符串直接解析为 DocumentFragment
      const range = document.createRange();
      range.setStartAfter(target);
      const fragment = range.createContextualFragment(elem);
      target.parentNode.insertBefore(fragment, target);
    } else {
      target.parentNode.insertBefore(elem, target);
    }
  }
}